'use strict';
import {getInstance} from './assignment';

// Assign-to-model actions have many side effect.
// Update actions are for when the model ID is not changing, but its data has.
// Updates will generally have distinct side effects (from assign actions), if any.

const UPDATE_ORGANIZATION = '@@app-model/UPDATE_ORGANIZATION';

/**
 *
 * @param organization
 * @return {ReduxAction}
 */
export function updateOrganizationInModel(organization) {
  return {
    type: UPDATE_ORGANIZATION,
    payload: {
      organization: getInstance(organization),
    },
  };
}
updateOrganizationInModel.TYPE = UPDATE_ORGANIZATION;



// WEBPACK FOOTER //
// ./src/js/app/model/actions/updateModel.js